import styled from 'styled-components';
export const CustomizedSelect = styled.div`
  .image-checked {
    width: 20px;
    height: 20px;
  }
`;
